const insuranceOrderOfBenefits = [
  'Primary',
  'Secondary',
  'Secondary As Primary',
  'Tertiary',
];

export default insuranceOrderOfBenefits;



// WEBPACK FOOTER //
// ./src/config/insuranceOrderOfBenefits.js